<template>
  <div class="talent-page">
    <div class="banner" v-if="deviceType == 'pc'"><div class="w"></div></div>
    <img src="../../assets/images/home/rlzy.png" alt="" v-else />
    <div v-if="deviceType == 'pc'" class="w">
      <div class="local w">
        人力资源:
        <a
          v-for="(item, i) in typeList"
          :key="i"
          :class="typeActive === item.id ? 'active' : ''"
          @click="clickType(item)"
          >{{ item.title }}</a
        >
      </div>
      <div class="talent-box">
        <div class="title"></div>
        <div class="culture"></div>
      </div>
    </div>
    <div v-else>
      <div class="local">
        人力资源:
        <a
          v-for="(item, i) in typeList"
          :key="i"
          :class="typeActive === item.id ? 'active' : ''"
          @click="clickType(item)"
          >{{ item.title }}</a
        >
      </div>
      <div class="talent-box">
        <div class="title">企业文化</div>
        <div class="culture">
          <img
            src="../../assets/images/talent/talent-1.png"
            alt=""
            class="culture-img"
          />
          <img src="../../assets/images/talent/talent-2.png" alt="" />
          <!-- <img src="../../assets/images/talent/corporate-culture.png" alt="" /> -->
        </div>
      </div>
    </div>
    <blockSidebar />
  </div>
</template>
<script>
import(
  `@/assets/css/${
    navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
      ? 'mobile'
      : 'pc'
  }/talent.scss`
)
import blockSidebar from '@/components/block-sidebar'
export default {
  // 人力资源
  components: { blockSidebar },
  data() {
    return {
      typeActive: '1',
      typeList: [
        {
          id: '1',
          title: '企业文化',
        },
        {
          id: '2',
          title: '人才理念',
        },
        {
          id: '3',
          title: '教育培训', //categoryId:25
        },
        {
          id: '4',
          title: '诚聘英才', //categoryId:19
        },
      ],
    }
  },
  computed: {
    deviceType() {
      return this.$store.state.app.deviceType
    },
  },
  methods: {
    clickType(v) {
      this.typeActive = v.id
      if (v.id == 2) {
        this.$router.push('/talent/concept')
      } else if (v.id == 3) {
        this.$router.push(`/talent/education`)
      } else if (v.id == 4) {
        this.$router.push(`/talent/corporateCulture`)
      }
    },
  },
}
</script>
<style scoped lang="scss">
.banner {
  background: url(~@/assets/images/home/banner-rencai.gif) no-repeat center;
}
</style>
